<template>
  <div class="hmt-video-slideshow">
    <video controls controlsList="nodownload noremoteplayback noplaybackrate" disablePictureInPicture>
      <source :src="url" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'HMTVideoSlideshow',
    computed: {
      ...mapGetters('tour', ['getVideoSlideshow', 'getBranded']),
      url () {
        return this.getBranded ? this.getVideoSlideshow.urlBranded : this.getVideoSlideshow.urlUnbranded;
      }
    }
  }
</script>

<style lang="scss">
  .hmt-video-slideshow {
    position: relative;
    width: 100%;
    background-color: #000;
    height: auto;
    padding-top: 56.25%;

    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
